export const PRODUCTS = Object.freeze({
  spamIcon: "assets/branding/SpamTitan.svg",
  spamDescription: "Email Anti-Spam Solution",

  webIcon: "assets/branding/WebTitan.svg",
  webDescription: "DNS Filtering",

  safeIcon: "assets/branding/SafeTitan.png",
  safeDescription: "Security Awareness Training",

  arcIcon: "assets/branding/ArcTitan.svg",
  arcDescription: "Security Archiving Training",

  userLinksTitle: "Security",
});

export const PRODUCTS_TITLE = Object.freeze({
  SAFE: "Safe",
  SPAM: "Spam",
  ARC: "Arc",
  WEB: "Web",
});

export const PRODUCTS_LINK = Object.freeze({
  SAFE: "https://www.titanhq.com/safetitan-customer-signup?from_product=webtitan&to_product=safetitan",
  SPAM: "https://www.titanhq.com/spamtitan-customer-signup?from_product=webtitan&to_product=spamtitan",
  ARC: "https://www.titanhq.com/arctitan-customer-signup?from_product=webtitan&to_product=arctitan",
  WEB: "https://www.titanhq.com/webtitan-customer-signup?from_product=webtitan&to_product=webtitan",
});

export const PRODUCTS_DESCRIPTION = Object.freeze({
  SAFE: "Security Awareness Training",
  SPAM: "Email Anti-Spam Solution",
  ARC: "Email Archiving Solution",
  WEB: "DNS Filtering",
});

export const SPAM_CONTENT = Object.freeze({
  line1:
    "Advanced email phishing protection with AI driven, zero-day threat intelligence",
  line2:
    "Best-in-class protection against phishing, spear phishing and malware",
  line3:
    "Check every URL on every click - blocks user access to malicious or suspicious URLs",
});

export const ARC_CONTENT = Object.freeze({
  line1:
    "Cloud based email archiving - reduces the cost and complexity of archiving emails and satisfy discovery requests",
  line2: "Data loss prevention and regulatory and legal compliance",
  line3:
    "Significantly enhances Office 365 email search and storage functionality",
});

export const SAFE_CONTENT = Object.freeze({
  line1: "Security Awareness Training (SAT) powering human layer protection",
  line2:
    "Delivery contextual training in real-time. ONLY available from SafeTitan.",
  line3: "Unlimited phishing simulations",
});
export const WEB_CONTENT = Object.freeze({
  line1: "Advanced threat protection, DNS security and content filtering",
  line2: "Proactive protection from malicious web threats and attacks",
  line3: "Scalable & fast",
});

export default {};
